import React, { useEffect, useState } from 'react'
import './search.css'
import { Select } from "antd"
import { Modal } from 'react-bootstrap';
import { heightList, religionAndCommunityList, languageList } from "../../data"
import { countryAndcities } from '../../cities.js'
import { Link } from 'react-router-dom'
import { extractCastes } from '../../utilities/utilities'
import { useSelector } from 'react-redux'
import axios from "axios"
import key from '../../key'
import { useCookies } from "react-cookie"
import { PulseLoader } from 'react-spinners'


const { Option } = Select

const BasicSearch = () => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false)
  const { user } = useSelector(state => state.user)
  const [lookingFor, setLookingFor] = useState("")
  const [age1, setAge1] = useState(18)
  const [age2, setAge2] = useState(70)
  const [height1, setHeight1] = useState("4'0\"")
  const [height2, setHeight2] = useState("6'9\"")
  const [religion, setReligion] = useState(user?.personalDetails?.religion)
  const [maritalStatus, setMaritalStatus] = useState(user?.personalDetails?.maritalStatus)
  const [motherTongue, setMotherTongue] = useState(user?.personalDetails?.motherTongue)
  const [community, setCommunity] = useState(user?.personalDetails?.community)
  const [country, setCountry] = useState(user?.personalDetails?.countryLiving)
  const [allCasts, setAllCasts] = useState([])
  const [showResults, setShowResults] = useState()
  const [userId, setUserId] = useState("")
  //eslint-disable-next-line
  const [cookies, setCookie] = useCookies(['x-auth-token']);

  const handleClose = () => setShow(false);
  const handleSearch = async () => {
    let gend;
    if (user?.gender === "Male") {
      gend = "Female"
    } else if (user?.gender === "Female") {
      gend = "Male"
    }
    let oppositeItems = [];
    for (const item of lookingFor) {
      if (gend === "Male" && item === 'Groom/Bride') {
          oppositeItems.push('Bride');
      } else if (gend === 'Male' && item === 'Boy Friend/Girl Friend') {
          oppositeItems.push('Girl Friend');
      } else if (gend === "Female" && item === 'Groom/Bride') {
          oppositeItems.push('Groom');
      } else if (gend === 'Female' && item === 'Boy Friend/Girl Friend') {
          oppositeItems.push('Boy Friend');
      }
  }
  let values = {
    lookingFor:oppositeItems,
    gender: gend,
    age1,
    age2,
    height1,
    height2,
    religion,
    maritalStatus,
    motherTongue,
    community,
    countryLiving: country,
    }
   
    setShow(true)

    try {
      setLoading(true)
      const res = await axios.post(`${key}/api/user/basic-search`, values, {
        headers: {
          "x-auth-token": cookies["x-auth-token"]
        }
      });
      if (res?.data?.results?.length === 0) {
        setShowResults(null)
      } else {
        setShowResults(res?.data?.results)
      }
      setLoading(false)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    setAllCasts(extractCastes())
  }, [])
  const searchByUserId = async () => {
    setShow(true)
    setLoading(true)
    try {
      const res = await axios.get(`${key}/api/user/search-by-userId/${userId}`, {
        headers: {
          "x-auth-token": cookies["x-auth-token"]
        }
      });
      if (res?.data?.results?.length === 0) {
        setShowResults(null)
      } else {
        setShowResults(res?.data?.results)
      }
      setLoading(false)
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <div className='container'>
      <div className='basicSearch search-bar mb-4 backgroundLight'>
        <h4 className='text-center'>Search Member by Id</h4>
        <div className='d-flex justify-content-between'>
          <div>
            <label>Member Id</label>
            <input value={userId} onChange={(e) => setUserId(e.target.value)} type="text" placeholder='LD000123456789' />
          </div>
          <button onClick={searchByUserId}>Search</button>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Search Result</Modal.Title>
        </Modal.Header>
        {loading ? <Modal.Body> <div className="loading-spinner"><PulseLoader size={25} color="#fa585b" /></div> </Modal.Body> : <Modal.Body>
          {showResults ? showResults?.map((result, index) => (
            <div key={index} className="main-search-card row">
              <div className="col-md-5">
                <div>{result?.userId}</div>
              </div>
              <div className="col-md-4">
                <div>{result?.firstName} {result?.lastName}</div>
              </div>
              <div className="col-md-3">
                <Link to={`/view-profile/${result?._id}`}>View Profile</Link>
              </div>
            </div>
          )) : <Modal.Body> <div className="text-center">No Results Found</div></Modal.Body>}
        </Modal.Body>}
      </Modal>
      <div className='basicSearch backgroundLight'>
        <h4 className='text-center'>Basic Search</h4>
        <div className='row'>
          <div className="col-md-4">Looking For</div>
          <div className="col-md-8">
            <Select mode='multiple' placeholder="You are Looking for" style={{ width: 600 }} onChange={(e) => setLookingFor(e)}>
              <Option value="Groom/Bride">Groom/Bride</Option>
              <Option value="Boy Friend/Girl Friend">Boy Friend/Girl Friend </Option>
            </Select>
          </div>

          <div className='listtt'></div>
          <div className="col-md-4">Age</div>
          <div className="col-md-8">
            <Select style={{ width: 100 }} onChange={(e) => setAge1(e)} defaultValue={"18"}>
              {Array.from({ length: 70 - 18 + 1 }, (_, i) => i + 18).map((age) => (
                <Option key={age} value={age}>
                  {age}
                </Option>
              ))}
            </Select>
            <span> to </span>
            <Select style={{ width: 100 }} onChange={(e) => setAge2(e)} defaultValue={"74"}>
              {Array.from({ length: 70 - 18 + 1 }, (_, i) => i + 18).map((age) => (
                <Option key={age} value={age}>
                  {age}
                </Option>
              ))}
            </Select>
          </div>
          <div className='listtt'></div>

          <div className="col-md-4">Height</div>
          <div className="col-md-8">
            <Select style={{ width: 100 }} onChange={(e) => setHeight1(e)} defaultValue={"4'0\""}>
              {heightList.map((height, index) => (
                <Option key={index} value={height}>
                  {height}
                </Option>
              ))}
            </Select>
            <span> to </span>
            <Select style={{ width: 100 }} onChange={(e) => setHeight2(e)} defaultValue={"6'9\""}>
              {heightList.map((height, index) => (
                <Option key={index} value={height}>
                  {height}
                </Option>
              ))}
            </Select>
          </div>
          <div className='listtt'></div>

          <div className="col-md-4">Marital Status</div>
          <div className="col-md-8">
            <Select style={{ width: 600 }} onChange={(e) => setMaritalStatus(e)} defaultValue={user?.personalDetails?.maritalStatus}>
              <Option value="Never Married">Never Married</Option>
              <Option value="Divorced">Divorced</Option>
              <Option value="Widowed">Widowed</Option>
              <Option value="Awaiting Divorce">Awaiting Divorce</Option>
              <Option value="Annulled">Annulled</Option>
            </Select>
          </div>

          <div className='listtt'></div>

          <div className="col-md-4">Religion</div>
          <div className="col-md-8">
            <Select style={{ width: 600 }} onChange={(e) => setReligion(e)} defaultValue={user?.personalDetails?.religion}>
              {
                religionAndCommunityList.map((religionAndCommunity, index) => (
                  <Option key={index} value={religionAndCommunity.religion}>{religionAndCommunity.religion}</Option>
                ))
              }
            </Select>
          </div>

          <div className='listtt'></div>

          <div className="col-md-4">Mother Tongue</div>
          <div className="col-md-8">
            <Select style={{ width: 600 }} onChange={(e) => setMotherTongue(e)} defaultValue={user?.personalDetails?.motherTongue}>
              {languageList.map((language, index) => (
                <Option key={index} value={language}>
                  {language}
                </Option>
              ))}
            </Select>
          </div>


          <div className='listtt'></div>

          <div className="col-md-4">Community</div>
          <div className="col-md-8">
            <Select style={{ width: 600 }} onChange={(e) => setCommunity(e)} defaultValue={user?.personalDetails?.community}>
              {allCasts.map((community, index) => (
                <Option key={index} value={community}>
                  {community}
                </Option>
              ))}
            </Select>
          </div>


          <div className='listtt'></div>

          <div className="col-md-4">Country Living In</div>
          <div className="col-md-8">
            <Select style={{ width: 600 }} onChange={(e) => setCountry(e)} defaultValue={user?.personalDetails?.countryLiving}>
              {countryAndcities.map((country, index) => (
                <Option key={index} value={country.country_name}>
                  {country.country_name}
                </Option>
              ))}
            </Select>
          </div>

          <div className='listtt'></div>

          <div className="col-md-4"></div>
          <div className="col-md-8 mt-4">
            <Link to="/advancedsearch">Advance Search options</Link>
          </div>

          <div className='listtt'></div>

          <div className='d-flex justify-content-center mt-4'>

            <Link className='btn btn-outline-warning customBtn' onClick={handleSearch}>
              Search
            </Link>
            {/* <Link className='mt-2' style={{ marginLeft: 10 }}>Reset</Link> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default BasicSearch
